import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsCreditCard2Front, BsHeadset, BsArrowRepeat, BsBoxSeam } from "react-icons/bs";
import "./ServiceHighlights.css";

const ServiceHighlights = () => {
  const items = [
    {
      icon: <BsCreditCard2Front size={28} />,
      title: "Pago protegido",
      subtitle: "Con todas las regulaciones",
    },
    {
      icon: <BsHeadset size={28} />,
      title: "Soporte individual",
      subtitle: "Ingenieros profesionales",
    },
    {
      icon: <BsArrowRepeat size={28} />,
      title: "Garantía 100%",
      subtitle: "Defectos y errores",
    },
    {
      icon: <BsBoxSeam size={28} />,
      title: "Envíos a toda Colombia",
      subtitle: "",
    },
  ];

  return (
    <div className="service-highlights">
      <Container>
        <Row className="g-3">
          {items.map((item, index) => (
            // Cambio clave: de xs={12} a xs={6}
            // Ahora, en pantallas pequeñas se verán dos columnas (6 + 6 = 12)
            <Col key={index} xs={6} md={3}> 
              <div className="service-highlights-item">
                <div className="service-highlights-icon">{item.icon}</div>
                <div>
                  <strong className="service-highlights-title">{item.title}</strong>
                  <div className="service-highlights-subtitle">{item.subtitle}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ServiceHighlights;